import { Box } from "@mui/material";
import "./whitePanel.css";

const WhitePanel = ({ sx = {}, children }) => {
  return (
    <Box className="panel" sx={sx}>
      {children}
    </Box>
  );
};
export default WhitePanel;
